module.exports = __webpack_public_path__ + "static/android-chrome-512x512-09f9f627eca36d49b6b6ad7fac72875f.png";